import React from "react";
import Field from "../shared/Field";
import { inputStyle } from "../shared/inputStyle";
import { formatAmountInput } from "../utils/format";

export default function ExecutionForm({
  unitLabel,
  executionAmount,
  setExecutionAmount,
  association,
  setAssociation,
}) {
  return (
    <>
      <Field label={`مبلغ محکوم‌به یا مورد اجرا (${unitLabel})`}>
        <input
          type="text"
          inputMode="numeric"
          value={executionAmount}
          onChange={(e) =>
            setExecutionAmount(formatAmountInput(e.target.value))
          }
          placeholder="مثلاً 8,000,000,000"
          className="input"
          style={inputStyle}
        />
      </Field>

      <div className="mt-5">
        <Field label="نظام صنفی وکیل (برای تسهیم تمبر مالیاتی)">
          <select
            value={association}
            onChange={(e) => setAssociation(e.target.value)}
            className="input"
            style={inputStyle}
          >
            <option value="kanoon">کانون وکلای دادگستری</option>
            <option value="markaz">
              مرکز امور وکلا و مشاوران قوه قضائیه
            </option>
          </select>
        </Field>
      </div>
    </>
  );
}
